<div class="row space-between align-center w100">
  <h4 i18n class="strong">Team Members</h4>
  <rr-btn
    type="Secondary"
    iconStart="add"
    (btnclick)="inviteDisabled === false ? invte() : null"
    [disabled]="inviteDisabled"
    >Invite</rr-btn
  >
</div>
<table class="memberarea">
  <tr *ngFor="let member of user?.licenseMembers">
    <td class="avatar"><rr-user-avatar [user]="member"></rr-user-avatar></td>
    <td class="name">{{ member.prename }} {{ member.lastname }}</td>
    <td class="email tiny">
      {{ member.email }}
    </td>
    <td class="actions">
      <rr-btn
        type="Action"
        iconStart="trash"
        *ngIf="member.id !== user.id"
      ></rr-btn>
    </td>
  </tr>
</table>
